import { render, staticRenderFns } from "./franchisee-add.vue?vue&type=template&id=47682a98&scoped=true&"
import script from "./franchisee-add.vue?vue&type=script&lang=js&"
export * from "./franchisee-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47682a98",
  null
  
)

export default component.exports